import React from 'react'
import { Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import './Team.css'

const { Title, Paragraph } = Typography

const members = [
    {
        name: 'Lucas',
        roleKey: 'coFounder',
        city: 'Cologne',
        image: '/img/Lucas.jpg',
    },
    {
        name: 'Felipe',
        roleKey: 'coFounder',
        city: 'Munich',
        image: '/img/Felipe.jpg',
    },
    {
        name: 'Julio',
        roleKey: 'organizerDeveloper',
        city: 'Munich',
        image: '/img/Julio.jpeg',
    },
    {
        name: 'Oséias',
        roleKey: 'organizer',
        city: 'Munich',
        image: '/img/Oseias.jpeg',
    },
    {
        name: 'Leila',
        roleKey: 'organizer',
        city: 'Bonn',
        image: '/img/Leila.jpg',
    },
]

const Team: React.FC = () => {
    const { t } = useTranslation()

    return (
        <>
            <Title className="title team" level={3}>
                {t('about.team.title')}
            </Title>
            <div className="team-wrapper">
                {members.map((member) => (
                    <div key={member.name} className="team-member-card">
                        <img
                            className="team-member-image"
                            src={member.image}
                            alt={member.name}
                        />
                        <div className="team-member-info">
                            <Title className="title team-member-name" level={4}>
                                {member.name}
                            </Title>
                            <Paragraph className="team-member-extra">
                                {t(`about.team.roles.${member.roleKey}`)}
                            </Paragraph>
                            <Paragraph className="team-member-extra">
                                {member.city}
                            </Paragraph>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default Team
